import { pick } from 'util/objects'

export const getRecipientInput = user =>
  pick(['id', 'email', 'phone_number', 'name'], user)
